export default "/fonts/vendor/@quasar/extras/fontawesome-v6/fa-brands-400.woff2?c210719e60948b211a1260f79812efe5";